module.exports = __webpack_public_path__ + "img/instagram.4bc8fea8.png";